import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_BEGIN,
  SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_SUCCESS,
  SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_FAILURE,
  SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function createInternalProductContractSubscription(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/subscriptions/create-internal-product-contract-subscription`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateInternalProductContractSubscriptionError() {
  return {
    type: SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_DISMISS_ERROR,
  };
}

export function useCreateInternalProductContractSubscription() {
  const dispatch = useDispatch();

  const {
    createInternalProductContractSubscriptionPending,
    createInternalProductContractSubscriptionError,
  } = useSelector(
    (state) => ({
      createInternalProductContractSubscriptionPending:
        state.subscriptions.createInternalProductContractSubscriptionPending,
      createInternalProductContractSubscriptionError:
        state.subscriptions.createInternalProductContractSubscriptionError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(createInternalProductContractSubscription(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCreateInternalProductContractSubscriptionError());
  }, [dispatch]);

  return {
    createInternalProductContractSubscription: boundAction,
    createInternalProductContractSubscriptionPending,
    createInternalProductContractSubscriptionError,
    dismissCreateInternalProductContractSubscriptionError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createInternalProductContractSubscriptionPending: true,
        createInternalProductContractSubscriptionError: null,
      };

    case SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_SUCCESS:
      // The request is success
      return {
        ...state,
        createInternalProductContractSubscriptionPending: false,
        createInternalProductContractSubscriptionError: null,
      };

    case SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_FAILURE:
      // The request is failed
      return {
        ...state,
        createInternalProductContractSubscriptionPending: false,
        createInternalProductContractSubscriptionError: action.data.error,
      };

    case SUBSCRIPTIONS_CREATE_INTERNAL_PRODUCT_CONTRACT_SUBSCRIPTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createInternalProductContractSubscriptionError: null,
      };

    default:
      return state;
  }
}
